<template>
  <div class="notice_wrapper">
    <div class="notice_cont_outer">
      <div class="notice_title">
        <div class="m_outer">
          <div class="m_title">申报通知</div>
          <div class="m_tip">
            了解开发区最新服务动态搭上企业服务直通车
          </div>
        </div>
        <div class="noti_pic_s">
          <img :src="imgUrl+'noti_pic.png'"/>
        </div>
      </div>
    </div>
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
  </div>
</template>

<script>
export default {

  name: 'notice',
  data() {
    return {

    }
  },
  created(){

  },
  watch:{
  	$route(to,from){

  	}
  },
  methods: {

  }
}
</script>

<style scoped>
.notice_cont_outer {
  width: 1180px;
  margin: 0 auto;
  background: #fff url('/gyzhqyimgs/noti_bg.png') no-repeat -25px -150px;
}

.notice_title {
  height: 368px;
  display: flex;
  align-items: flex-end;
  position: relative;
}

.m_outer {
  padding: 20px;
}

.m_title {
  color: #143367;
  font-size: 28px;
  margin-bottom: 16px;
}

.m_tip {
  width: 160px;
  color: #2574AD;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.noti_pic_s {
  position: absolute;
  bottom: -20px;
  left: 50%;
  margin-left: 50px;
}

</style>



// WEBPACK FOOTER //
// src/components/NotiDeclare/notice.vue